import { configureTelemetry } from '@ms/yammer-telemetry';
import getClientContext from '@ms/yammer-web-support/dist/clientContext';
import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';
import { isLoadedFromPWA } from '@ms/yammer-web-support/dist/location';

import config from '../../config';

export const configure = async (): Promise<void> => {
  const isPWA = isLoadedFromPWA();
  const clientContext = { ...getClientContext(), isPWA };
  configureTelemetry({
    config,
    telemetryClientId: config.application.applicationId,
    hostingConfig: readHostingConfiguration(),
    skipNextCleanup: true,
    registerUnhandledEventsListener: true,
    isMsal: true,
    clientContext,
  });
};
